export default __webpack_public_path__ + "00d291615cc8f7992b4864d1a329f81d.png";